import * as yup from 'yup';

export const OptinSchemaBuilder = (optins) => {
    const optinsList = Array.isArray(optins) ? optins : [];
    const mandatoryOptins = optinsList.filter(optin => optin?.is_mandatory);

    const schema = {
        optins: yup.array()
            .of(yup.boolean())
            .test('mandatory-optins', 'All mandatory optins must be true', () => {
                return mandatoryOptins.every(optin => Boolean(optin?.value));
            }),
    };
    
    return schema;
};

export default OptinSchemaBuilder;